import { useClientSupportPageContext } from "../providers/ClientSupportPageProvider/useClientSupportPageContext";
import { useIsInboxSidebarCompact } from "./useIsInboxSidebarCompact";

/**
 * Tells whether the Inbox must render a single pane at a time instead of the
 * desktop multi-column layout.
 *
 * Single-pane mode is limited to narrow viewports and to channel views only
 * (tickets are excluded at this moment)
 */
export const useIsInboxSinglePane = (): boolean => {
  const { selectedView } = useClientSupportPageContext();

  const isSidebarCompact = useIsInboxSidebarCompact();

  return isSidebarCompact && selectedView.kind === "channel";
};
